import { render, staticRenderFns } from "./info-cards.vue?vue&type=template&id=25bee032&scoped=true"
import script from "./info-cards.vue?vue&type=script&lang=js"
export * from "./info-cards.vue?vue&type=script&lang=js"
import style0 from "./info-cards.vue?vue&type=style&index=0&id=25bee032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bee032",
  null
  
)

export default component.exports